export const manageSubscriptionLink = () => {
	const manageMySubscriptionLink = document.querySelector(
		'.js-my-account-manage-my-subscription',
	);

	if ( manageMySubscriptionLink ) {
		if ( window.subscriptionOrigin ) {
			if ( 'piano' === window.subscriptionOrigin ) {
				manageMySubscriptionLink.remove();
			}
		}
	}
};

export default manageSubscriptionLink;
